import React from 'react';

const Operation = (props) => (
    <div className="operation">
        <div className="description-section">
            <div className="descriptionHeader">{props.description}</div>
            {props.descriptionExtra && <div className="description">{props.descriptionExtra}</div>}
            {props.errorText && (
                <div className="error-container">
                    <span className="error">{props.errorText}</span>
                    {props.showUpgradeLogs && (
                        <span className="error showLogs" onClick={props.showUpgradeLogs}>
                            (Show Logs)
                        </span>
                    )}
                </div>
            )}
        </div>
        <button onClick={props.buttonClicked} disabled={props.buttonDisabled}>
            {props.buttonDescription}
        </button>
    </div>
);

export default Operation;
